module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('h1', {
    staticClass: "u"
  }, [_vm._v("\n    Клиенты\n    "), (_vm.total) ? _c('span', [_vm._v("(" + _vm._s(_vm.total) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Район")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadAddresses()
      }
    },
    model: {
      value: (_vm.filters.apartment__block__building__address__district__id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "apartment__block__building__address__district__id", $$v)
      },
      expression: "filters.apartment__block__building__address__district__id"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "- Все -"
    }
  }), _vm._v(" "), _vm._l((_vm.selectDistricts), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Улица")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadBuildings()
      }
    },
    model: {
      value: (_vm.filters.apartment__block__building__address__id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "apartment__block__building__address__id", $$v)
      },
      expression: "filters.apartment__block__building__address__id"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "- Все -"
    }
  }), _vm._v(" "), _vm._l((_vm.selectAddresses), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("№ дома")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadBlocks()
      }
    },
    model: {
      value: (_vm.filters.apartment__block__building__id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "apartment__block__building__id", $$v)
      },
      expression: "filters.apartment__block__building__id"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "- Все -"
    }
  }), _vm._v(" "), _vm._l((_vm.selectBuildings), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("№ подъезда")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.apartment__block__id),
      callback: function($$v) {
        _vm.$set(_vm.filters, "apartment__block__id", $$v)
      },
      expression: "filters.apartment__block__id"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "",
      "label": "- Все -"
    }
  }), _vm._v(" "), _vm._l((_vm.selectBlocks), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Номер договора")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filters.search),
      expression: "filters.search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.filters.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filters, "search", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.filters.apartment__block__id) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Начальная дата")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "input-id": "date-from",
      "input-class": "form-control",
      "type": "date",
      "placeholder": "Начальная дата"
    },
    model: {
      value: (_vm.dateFrom),
      callback: function($$v) {
        _vm.dateFrom = $$v
      },
      expression: "dateFrom"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Конечная дата")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "input-id": "date-to",
      "input-class": "form-control",
      "type": "date",
      "placeholder": "Конечная дата"
    },
    model: {
      value: (_vm.dateTo),
      callback: function($$v) {
        _vm.dateTo = $$v
      },
      expression: "dateTo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Количество месяцев")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.months),
      expression: "months"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.months)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.months = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.printBills.apply(null, arguments)
      }
    }
  }, [_vm._v("напечатать квитанции")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "margin-top": "25px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createPrintOrder.apply(null, arguments)
      }
    }
  }, [_vm._v("создать заказ на печать")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Начальная дата 2")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "input-id": "date-from2",
      "input-class": "form-control",
      "type": "date",
      "placeholder": "Начальная дата 2"
    },
    model: {
      value: (_vm.dateFrom2),
      callback: function($$v) {
        _vm.dateFrom2 = $$v
      },
      expression: "dateFrom2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Конечная дата 2")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "input-id": "date-to2",
      "input-class": "form-control",
      "type": "date",
      "placeholder": "Конечная дата 2"
    },
    model: {
      value: (_vm.dateTo2),
      callback: function($$v) {
        _vm.dateTo2 = $$v
      },
      expression: "dateTo2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Количество месяцев 2")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.months2),
      expression: "months2"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.months2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.months2 = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), _c('resource-list', {
    attrs: {
      "url": "/clients",
      "current-sort": "contract_number",
      "init-sort-type": "asc",
      "resource-name": "clients",
      "action-routes": _vm.actionRoutes,
      "fields": _vm.fields,
      "filters": _vm.filters,
      "show-in-query": _vm.showInQuery,
      "init-page": _vm.initPage,
      "init-per-page": _vm.initPerPage,
      "storagePrfx": 'all-clients'
    },
    on: {
      "total": _vm.updateTotal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b7601c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/client/AllClients.vue
// module id = 675
// module chunks = 0